/* Pat Kay — shared chrome behavior: topbar pill morph, menu overlay, nav children, search/cart takeovers.
   Loaded at the end of <body> on every layout (Home included — all lookups are null-guarded). */

(function () {
  // ----- Scrolled top bar: detached pill -----
  function onScroll() {
    document.body.classList.toggle('nav-scrolled', window.scrollY > 24);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // ----- Menu overlay -----
  var overlay = document.getElementById('m-overlay');
  var openBtn = document.getElementById('menu-open');
  var closeBtn = document.getElementById('menu-close');

  // Rail line hugs whatever nav group is showing — the parent list, or an open
  // submenu — overshooting 100px past each end so it always frames the content.
  function sizeOverlayRail() {
    if (!overlay) return;
    var siteNav = overlay.querySelector('.site-nav');
    var rail = overlay.querySelector('.rail-line');
    if (!siteNav || !rail) return;
    var openItem = overlay.querySelector('.nav-item.open');
    var group = openItem ? openItem.querySelector('.children') : overlay.querySelector('.nav-list');
    if (!group) return;
    var top = Infinity, bottom = -Infinity;
    Array.prototype.forEach.call(group.children, function (el) {
      var r = el.getBoundingClientRect();
      if (!r.height) return;
      if (r.top < top) top = r.top;
      if (r.bottom > bottom) bottom = r.bottom;
    });
    if (top === Infinity) return;
    var OVERSHOOT = 100;
    var navTop = siteNav.getBoundingClientRect().top;
    rail.style.top = (top - OVERSHOOT - navTop) + 'px';
    rail.style.bottom = 'auto';
    rail.style.height = (bottom - top + OVERSHOOT * 2) + 'px';
  }
  // resize the rail, then place the active indicator one frame later (after the
  // rail-resize reflow settles, so its coordinates don't go stale)
  function syncOverlay() {
    sizeOverlayRail();
    requestAnimationFrame(refreshActiveIndicator);
    // re-place once more after layout fully settles (guards against the viewport
    // still resizing on first open); a no-op once coordinates are stable
    setTimeout(refreshActiveIndicator, 200);
  }
  window.addEventListener('resize', syncOverlay, { passive: true });

  if (overlay && openBtn) {
    openBtn.addEventListener('click', function () {
      document.body.classList.add('menu-open');
      overlay.setAttribute('aria-hidden', 'false');
      // reset to the parent list and replay the stagger
      overlay.querySelectorAll('.nav-item').forEach(function (li) {
        li.classList.remove('open');
        li.style.animation = '';
        li.style.opacity = '';
      });
      requestAnimationFrame(syncOverlay);
    });
  }
  function closeMenu() {
    if (!overlay) return;
    document.body.classList.remove('menu-open');
    overlay.setAttribute('aria-hidden', 'true');
  }
  if (closeBtn) closeBtn.addEventListener('click', closeMenu);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeMenu();
      document.querySelectorAll('.nav-item.open').forEach(function (o) { o.classList.remove('open'); });
      requestAnimationFrame(syncOverlay);
    }
  });

  // keep the finished state before cancelling the entrance animation:
  // a retained fill transform would make each li a containing block and hijack .children positioning
  document.querySelectorAll('.nav-item').forEach(function (li) {
    li.addEventListener('animationend', function () {
      li.style.opacity = '1';
      li.style.animation = 'none';
    });
  });

  // ----- Click/tap a parent with children to reveal them -----
  document.querySelectorAll('.nav-item.has-children > .nav-parent').forEach(function (parent) {
    parent.addEventListener('click', function (e) {
      e.preventDefault();
      var item = parent.closest('.nav-item');
      document.querySelectorAll('.nav-item.open').forEach(function (o) {
        if (o !== item) { o.classList.remove('open'); }
      });
      item.classList.add('open');
      requestAnimationFrame(syncOverlay);
    });
  });
  document.querySelectorAll('.children-back').forEach(function (btn) {
    btn.addEventListener('click', function () {
      btn.closest('.nav-item').classList.remove('open');
      requestAnimationFrame(syncOverlay);
    });
  });

  // ----- Overlay rail: grey segment follows hover, black segment marks the current page -----
  var railNav = overlay ? overlay.querySelector('.site-nav') : null;
  var hoverMark = overlay ? overlay.querySelector('.rail-indicator') : null;
  var activeMark = overlay ? overlay.querySelector('.rail-active') : null;

  function placeRailMark(mark, el) {
    if (!mark || !railNav) return;
    var navTop = railNav.getBoundingClientRect().top;
    var r = el.getBoundingClientRect();
    mark.style.top = (r.top - navTop - 15) + 'px';
    mark.style.height = (r.height + 30) + 'px';
  }

  // resolve a nav link's same-origin path (null for "#" anchors and offsite links)
  function railHrefPath(a) {
    var raw = a.getAttribute('href') || '';
    if (!raw || raw.charAt(0) === '#') return null;
    try {
      var u = new URL(raw, location.origin);
      if (u.origin !== location.origin) return null;
      return u.pathname.replace(/\/+$/, '');
    } catch (e) { return null; }
  }

  // which nav entry is the current page? a parent, or a parent via one of its children
  var overlayActive = (function () {
    if (!overlay) return null;
    var path = location.pathname.replace(/\/+$/, '');
    if (path === '') return null;
    var parents = overlay.querySelectorAll('.nav-item > .nav-parent');
    for (var i = 0; i < parents.length; i++) {
      if (railHrefPath(parents[i]) === path) {
        return { el: parents[i], item: parents[i].closest('.nav-item'), child: null };
      }
    }
    var kids = overlay.querySelectorAll('.children a');
    for (var j = 0; j < kids.length; j++) {
      if (railHrefPath(kids[j]) === path) {
        var it = kids[j].closest('.nav-item');
        return { el: it.querySelector('.nav-parent'), item: it, child: kids[j] };
      }
    }
    return null;
  })();

  function refreshActiveIndicator() {
    if (!activeMark || !railNav) return;
    if (!overlayActive) { railNav.classList.remove('has-active'); return; }
    var openItem = overlay.querySelector('.nav-item.open');
    // parent list showing → mark the active parent; a submenu open → mark the active child if it lives there
    var target = openItem
      ? (overlayActive.child && overlayActive.item === openItem ? overlayActive.child : null)
      : overlayActive.el;
    if (!target) { railNav.classList.remove('has-active'); return; }
    var wasActive = railNav.classList.contains('has-active');
    if (!wasActive) { activeMark.style.transition = 'none'; }
    placeRailMark(activeMark, target);
    if (!wasActive) {
      void activeMark.offsetHeight;
      activeMark.style.transition = '';
      railNav.classList.add('has-active');
    }
  }

  // only wire hover on real pointers — touch fires synthetic mouseenter on tap,
  // which would leave the grey segment stuck at the tapped item
  var canHover = !window.matchMedia || window.matchMedia('(hover: hover)').matches;
  if (overlay && hoverMark && railNav && canHover) {
    overlay.querySelectorAll('.nav-parent, .children a, .children-back').forEach(function (el) {
      el.addEventListener('mouseenter', function () {
        if (!railNav.classList.contains('indicator-on')) {
          hoverMark.style.transition = 'none';
          placeRailMark(hoverMark, el);
          void hoverMark.offsetHeight;
          hoverMark.style.transition = '';
          railNav.classList.add('indicator-on');
        } else {
          placeRailMark(hoverMark, el);
        }
      });
    });
    railNav.addEventListener('mouseleave', function () {
      railNav.classList.remove('indicator-on');
    });
  }

  // ----- Search & cart takeovers -----
  function closeAll() {
    document.body.classList.remove('search-open', 'cart-open');
    document.querySelectorAll('.u-overlay').forEach(function (o) { o.setAttribute('aria-hidden', 'true'); });
  }
  function openTakeover(cls, sel) {
    closeAll();
    var el = document.querySelector(sel);
    if (!el) return;
    document.body.classList.add(cls);
    el.setAttribute('aria-hidden', 'false');
  }
  document.querySelectorAll('.utilities a[aria-label="Search"]').forEach(function (s) {
    s.addEventListener('click', function (e) {
      e.preventDefault();
      openTakeover('search-open', '.u-overlay.search');
      setTimeout(function () {
        var i = document.getElementById('u-search-input');
        if (i) i.focus();
      }, 150);
    });
  });
  document.querySelectorAll('.utilities a[aria-label="Cart"]').forEach(function (c) {
    c.addEventListener('click', function (e) {
      e.preventDefault();
      openTakeover('cart-open', '.u-overlay.cart');
    });
  });
  document.querySelectorAll('.u-close').forEach(function (b) { b.addEventListener('click', closeAll); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
})();

// ----- Omnisend embedded forms: flatten onto the DS -----
// Omnisend's injected radius rules are id-scoped + !important, so stylesheet
// overrides can't win; inline !important can. Re-runs as the form builds async.
(function () {
  document.querySelectorAll('.omnisend-embed').forEach(function (wrap) {
    function flatten() {
      wrap.querySelectorAll('input, button, div').forEach(function (el) {
        el.style.setProperty('border-radius', '0', 'important');
      });
    }
    new MutationObserver(flatten).observe(wrap, { childList: true, subtree: true });
    flatten();
  });
})();

// ----- Image marquees: keep the loop gap-free at any viewport width -----
// The track animates translateX(-50%) across two identical groups, so each
// group must be at least viewport-wide or white space scrolls into view.
// Duration scales with the added width to keep the px/s speed unchanged.
(function () {
  var tracks = document.querySelectorAll('.marquee-track');
  if (!tracks.length) return;
  function fill() {
    tracks.forEach(function (track) {
      var groups = track.querySelectorAll('.marquee-group');
      if (!groups.length || !groups[0].offsetWidth) return;
      if (!track.dataset.pkBaseCount) {
        track.dataset.pkBaseCount = groups[0].children.length;
        track.dataset.pkBaseDuration = parseFloat(getComputedStyle(track).animationDuration) || 70;
      }
      var guard = 0;
      while (groups[0].offsetWidth < window.innerWidth && guard++ < 6) {
        groups.forEach(function (g) { g.innerHTML += g.innerHTML; });
      }
      track.style.animationDuration = (track.dataset.pkBaseDuration * groups[0].children.length / track.dataset.pkBaseCount) + 's';
    });
  }
  fill();
  window.addEventListener('resize', fill, { passive: true });
})();
